import { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Bot, Users2, Clock } from "lucide-react";

const COLOR_BG = { sky: "bg-sky-100 text-sky-800 border-sky-200", amber: "bg-amber-100 text-amber-800 border-amber-200", emerald: "bg-emerald-100 text-emerald-800 border-emerald-200", rose: "bg-rose-100 text-rose-800 border-rose-200" };

export default function Schedule() {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!user) return;
    api.get(`/schedule/${user.grade}`).then(r => setData(r.data));
  }, [user]);

  if (!data) return <div className="p-12 text-center text-slate-500">Loading schedule…</div>;

  return (
    <div data-testid="schedule-page" className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-[0.22em] font-bold text-slate-500 mb-2">Your weekly plan · Grade {data.grade}</div>
        <h1 className="text-5xl font-black text-slate-900 tracking-tight">3 hours · 5 days · 50/50</h1>
        <p className="text-slate-600 mt-3 max-w-2xl text-lg">A balanced week of {data.ai_hours}h AI tutoring and {data.live_hours}h live certified teacher sessions — totaling {data.weekly_hours} learning hours.</p>
      </div>

      <div className="grid lg:grid-cols-5 gap-4">
        {data.days.map((d) => (
          <div key={d.day} data-testid={`day-${d.day}`} className="bg-white rounded-3xl p-5 border border-slate-100 shadow-sm">
            <div className="text-xs font-black uppercase tracking-widest text-slate-500 mb-4">{d.day}</div>
            <div className="space-y-3">
              {d.blocks.map((b, i) => (
                <div key={i} data-testid={`block-${d.day}-${i}`} className={`rounded-2xl p-4 border ${COLOR_BG[b.color] || COLOR_BG.sky}`}>
                  <div className="flex items-center gap-2 text-xs font-black mb-1">
                    {b.mode === "ai" ? <Bot size={12} strokeWidth={3}/> : <Users2 size={12} strokeWidth={3}/>}
                    <span className="uppercase tracking-widest">{b.mode === "ai" ? "AI Tutor" : "Live Teacher"}</span>
                  </div>
                  <div className="font-black text-base leading-tight">{b.subject_name}</div>
                  <div className="flex items-center gap-1 text-xs mt-2 font-bold opacity-70">
                    <Clock size={11} strokeWidth={3}/> {b.start} – {b.end}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
